import OzonFbsOrders from './OzonFbsOrders';
import OzonFbsSettings from './OzonFbsSettings';
import OzonFbsFfCalculator from './OzonFbsFfCalculator';
import usePersistedState from '../../../../hooks/usePersistedState';

const FBS_TABS = [
    { key: 'orders', label: 'Заказы' },
    { key: 'ff_calc', label: 'Расчёт FBS ФФ' },
    { key: 'settings', label: 'Настройка FBS' },
];

function OzonFbsPanel({ accountId }) {
    // Вкладка переживает F5 — раньше любое обновление страницы выкидывало в "Заказы".
    const [tab, setTab] = usePersistedState(`ozon-fbs-tab-${accountId || 'none'}`, 'orders');

    return (
        <div style={{ marginTop: 12 }}>
            <div className="account-tabs account-tabs--secondary" style={{ marginBottom: 16 }}>
                {FBS_TABS.map(t => (
                    <button
                        key={t.key}
                        type="button"
                        className={tab === t.key ? 'active' : ''}
                        onClick={() => setTab(t.key)}
                    >
                        {t.label}
                    </button>
                ))}
            </div>

            {tab === 'orders' && <OzonFbsOrders accountId={accountId} />}
            {tab === 'ff_calc' && <OzonFbsFfCalculator accountId={accountId} />}
            {tab === 'settings' && <OzonFbsSettings accountId={accountId} />}
        </div>
    );
}

export default OzonFbsPanel;
